module.exports = __webpack_public_path__ + "static/img/gbLogo@2x.42599ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gbLogo@2x.png
// module id = O92H
// module chunks = 1